import { render, staticRenderFns } from "./ServicePoliticsLayout.vue?vue&type=template&id=5c0a342a"
import script from "./ServicePoliticsLayout.vue?vue&type=script&lang=js"
export * from "./ServicePoliticsLayout.vue?vue&type=script&lang=js"
import style0 from "./ServicePoliticsLayout.vue?vue&type=style&index=0&id=5c0a342a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports